export default __webpack_public_path__ + "208c95245b9ee100cd7866f835f76bb0.png";